import React from "react";

const steps = [
  {
    num: "01",
    title: "Milling",
    desc: "Pulverizing ilmenite ore to 325 mesh for optimal acid reaction surface area.",
  },
  {
    num: "02",
    title: "Digestion",
    desc: "Sulphuric acid reaction controlled within lead-lined digestors.",
  },
  {
    num: "03",
    title: "Crystallization",
    desc: "Separation of ferrous sulphate through cooling and pusher centrifuges.",
  },
  {
    num: "04",
    title: "Hydrolysis",
    desc: "Critical control of particle size through thermal hydrolysis steps.",
  },
  {
    num: "05",
    title: "Calcination",
    desc: "High-temperature rotary calciner with Wet ESP for emission control.",
  },
  {
    num: "06",
    title: "Packing",
    desc: "Automated bagging under our flagship VELOX Titanium brand.",
  },
];

export default function ProcessSection() {
  return (
    <section className="px-6 py-24" id="process">
      <div className="mx-auto max-w-screen-xl">
        <div className="mb-16 flex items-end justify-between border-b border-border pb-6">
          <h2 className="text-4xl font-bold tracking-tight">Production Pipeline</h2>
          <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
            Technical Workflow
          </span>
        </div>
        <div className="grid grid-cols-1 gap-px bg-border md:grid-cols-6">
          {steps.map((step, i) => (
            <div
              key={step.num}
              className="animate-fade-in flex h-full flex-col bg-background p-6"
              style={{ animationDelay: `${(i + 1) * 200}ms` }}
            >
              <span className="mb-8 font-mono text-m text-accent">{step.num}</span>
              <h3 className="mb-4 text-m font-bold uppercase tracking-widest">
                {step.title}
              </h3>
              <p className="text-xm leading-relaxed text-muted-foreground">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
